import { useState, type FormEvent } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { api, ErrorApi } from '../lib/api'

export function Entrar() {
  const clienteQuery = useQueryClient()
  const [usuario, setUsuario] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  const entrar = async (evento: FormEvent) => {
    evento.preventDefault()
    setEnviando(true)
    setError(null)
    try {
      await api('/api/auth/entrar', { metodo: 'POST', cuerpo: { usuario, password } })
      await clienteQuery.invalidateQueries({ queryKey: ['yo'] })
    } catch (e) {
      setError(e instanceof ErrorApi ? e.message : 'No se ha podido entrar')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center px-4 py-10">
      <form
        onSubmit={entrar}
        className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900"
      >
        <img
          src="/logo.png"
          alt="Codoh"
          width={224}
          height={60}
          className="mb-5 h-12 w-auto rounded-lg dark:bg-white dark:px-2 dark:py-1"
        />
        <p className="mb-6 text-sm text-slate-500">Entra con tu cuenta de la empresa.</p>

        <label className="mb-1 block text-xs font-semibold text-slate-500" htmlFor="usuario">
          Usuario
        </label>
        <input
          id="usuario"
          type="text"
          autoComplete="username"
          autoCapitalize="none"
          autoFocus
          required
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          className="mb-4 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:border-marca-500 focus:ring-2 focus:ring-marca-100 dark:border-slate-700 dark:bg-slate-950"
        />

        <label className="mb-1 block text-xs font-semibold text-slate-500" htmlFor="password">
          Contraseña
        </label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:border-marca-500 focus:ring-2 focus:ring-marca-100 dark:border-slate-700 dark:bg-slate-950"
        />

        {error && <p className="mt-4 text-sm text-red-600">{error}</p>}

        <button
          type="submit"
          disabled={enviando}
          className="mt-6 w-full rounded-lg bg-marca-700 px-4 py-2.5 text-sm font-bold text-white transition hover:bg-marca-800 disabled:opacity-50"
        >
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  )
}
